<template>
  <v-dialog v-model="editing" width="500">
    <v-dialog v-model="confirmDeleteDialog" width="500">
      <template></template>
      <confirm-modal
        v-if="confirmDeleteDialog"
        confirmationText="Are you sure you want to delete this count item?"
        @dialog-clicked="deleteItem"
      />
    </v-dialog>

    <v-form ref="form">
      <v-card>
        <v-container>
          <h6 class="text-center py-4 h6">{{ isNew ? 'New' : 'Edit' }} Count Item</h6>

          <v-text-field
            v-model="localItem.name"
            label="Name"
            :rules="[v => !!v || 'Name is required']"
          />

          <v-select
            :items="categories"
            v-model="localItem.category"
            item-text="name"
            item-value="id"
            label="Category"
          />

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model.number="localItem.min_value"
                label="Min Value"
                type="number"
                clearable
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.number="localItem.max_value"
                label="Max Value"
                type="number"
                clearable
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model.number="localItem.sort_order"
                label="Sort Order"
                type="number"
              />
            </v-col>
          </v-row>

          <v-checkbox v-model="localItem.allow_decimals" label="Allow Decimals" />
          <v-checkbox v-model="localItem.is_active" label="Is Active" />

          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-row align="end">
            <v-col cols="6">
              <v-btn v-if="!isNew" color="error" text @click="confirmDeleteDialog = true">
                Delete
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn color="error" text @click="$emit('dialog-clicked')">Cancel</v-btn>
              <v-btn
                :disabled="!localItem.name"
                color="success"
                text
                @click="submitForm"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import ConfirmModal from '../modals/ConfirmModal.vue'

export default {
  name: 'EditCountItemModal',
  components: { ConfirmModal },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    countItemObject: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      confirmDeleteDialog: false,
      localItem: {}
    }
  },
  computed: {
    ...mapState({
      categories: state => state.categories.categories
    }),
    isNew() {
      return !this.countItemObject || !this.countItemObject.id
    }
  },
  watch: {
    countItemObject: {
      handler(val) {
        this.localItem = { ...val }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(['createCountItem', 'updateCountItem', 'deleteCountItem']),
    ...mapMutations(['setMessage']),
    submitForm() {
      const payload = {
        name: this.localItem.name,
        category: this.localItem.category,
        is_active: this.localItem.is_active,
        sort_order: this.localItem.sort_order || 0,
        min_value: this.localItem.min_value,
        max_value: this.localItem.max_value,
        allow_decimals: this.localItem.allow_decimals || false
      }

      if (this.isNew) {
        this.createCountItem(payload).then(() => {
          this.setMessage({ text: 'Count Item Created', type: 'success', alert: true })
        })
      } else {
        payload.id = this.countItemObject.id
        this.updateCountItem(payload).then(() => {
          this.setMessage({ text: 'Count Item Updated', type: 'success', alert: true })
        })
      }
      this.$emit('dialog-clicked')
    },
    deleteItem(confirmed) {
      if (confirmed) {
        this.deleteCountItem({ id: this.countItemObject.id }).then(() => {
          this.setMessage({ text: 'Count Item Deleted', type: 'success', alert: true })
        })
      }
      this.$emit('dialog-clicked')
    }
  }
}
</script>
